import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { singletonHook } from 'react-singleton-hook';

import { IAthleteSport } from '@interfaces/lookups';
import { handleGetAthleteSports } from '@store/features/athleteSports/actions';
import {
  athleteSportsErrorSelector,
  athleteSportsIsLoadingSelector,
  athleteSportsIsReadySelector,
  athleteSportsSelector,
} from '@store/features/athleteSports/selectors';
import { userDataSelector } from '@store/features/auth/user/selectors';
import useDispatch from '@store/hooks/useDispatch';

import useFetchLookupData from './useFetchLookupData';

const useAthleteSports = (): IAthleteSport[] => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const data = useSelector(athleteSportsSelector);
  const isLoading = useSelector(athleteSportsIsLoadingSelector);
  const isReady = useSelector(athleteSportsIsReadySelector);
  const error = useSelector(athleteSportsErrorSelector);
  const user = useSelector(userDataSelector);

  const handleFetch = useCallback(() => {
    user?.showSports && dispatch(handleGetAthleteSports());
  }, [dispatch, user]);

  useFetchLookupData({
    isReady,
    isLoading,
    error: error && t('errors.athleteSportsError'),
    handleFetch,
  });

  return data;
};

export default singletonHook([], useAthleteSports);
